import Vue from "vue";
import App from "./ShareDetail.vue";
//vant ui 组件
import Vant from "vant";
import "vant/lib/index.css";
import 'vant/lib/icon/local.css';
import "@/assets/css/common.css";
Vue.use(Vant);

//国际化
import i18n from '@/lang';

// 引入字体库
import "@/assets/css/font.css";

// 挂载工具类
import '@/kabala/js/kstore.js';
import $kutil from "@/kabala/js/kutil";
import $khttp from "@/kabala/js/khttp";

import $kmobile from "@/kabala/js/kmobile";
import $kuser from "@/kabala/js/kuser";
import kmutils from '@/kabala/js/kmutils'
import $CommFuncs from '@/kabala/js/commfuncs'
import $MobileApi from "@/kabala/js/api.all";
Vue.prototype.$khttp = $khttp;
Vue.prototype.$kutil = $kutil;
Vue.prototype.$kmobile = $kmobile;

Vue.prototype.$kuser = $kuser;
Vue.prototype.$kmutils = kmutils;
Vue.prototype.$CommFuncs = $CommFuncs;
Vue.prototype.$MobileApi = $MobileApi;

Vue.config.productionTip = false;


var $app = new Vue({
    i18n,
    render: (h) => h(App),
})
window.$app = $app;
window.$KabalaI18n = $app;
console.log('share.js<<<')

$app.$mount("#app");
